import styled from 'styled-components'

export const PolicyWrapper = styled.div`
	padding: 0 0 16px 0;
	border-bottom: 1px solid ${({ theme }) => theme.color.divider};
	display: flex;
	flex-direction: column;
	row-gap: 8px;

	&:last-child {
		border-bottom: none;
	}

	& > b {
		display: block;
		margin-bottom: 18px;
	}
`
